<template>
  <div class="radish">
    <div class="search-tabs">
      <div class="search-tab" @click="$router.push('radish2')">模糊搜索</div>
      <div class="search-tab search-tab-active">条件搜索</div>
      <div class="search-tab" @click="$router.push({ name: 'listdocuments', query: { from: 'radish' } })">
        资源库搜索
      </div>
    </div>
    <radishList
      ref="radishList"
      :fav="currentFav"
      :show-search="true"
      :is-full="true"
      style="padding-left:30px"
    ></radishList>
    <template v-if="isAdmin">
      <el-button v-if="matching" class="match-btn" size="mini" round>匹配中...</el-button>
      <template v-else>
        <el-button
          v-if="matchPid"
          class="match-btn"
          type="primary"
          size="mini"
          round
          @click="recommendMatch({ pid: matchPid })"
          >重试</el-button
        >
        <el-button v-else class="match-btn" type="primary" size="mini" round @click="showUpload">智能匹配</el-button>
      </template>
    </template>
    <!-- <el-button size="mini" class="match-btn" style="right: 110px" @click="$router.push('radish2')">模糊搜索</el-button> -->
    <UploadDialog ref="UploadDialog" title="上传至少三份简历" type="tmpCv" :on-success="uploadSuccess"></UploadDialog>
    <!-- <favorites ref="favorites" :on-click-item="setCurrentFav" :open-favorites="openFavorites"></favorites> -->
    <conditions ref="conditions" :on-click-item="setCurrentCon"></conditions>
  </div>
</template>
<script>
// import favorites from './favorites'
import conditions from './conditions'

export default {
  components: { conditions },
  data: function() {
    return {
      currentFav: {},
      matching: false,
      matchPid: '',
      files: [],
      openFavorites: false,
    }
  },
  computed: {
    isAdmin() {
      return app.user['角色'] && app.user['角色'].includes('管理员')
    },
  },
  mounted() {
    // this.openFavorites = !!(this.$route.query && this.$route.query.openFavorites)
  },
  methods: {
    closeDetail: function() {
      this.isDetailShow = false
    },
    setCurrentFav: function(fav) {
      this.currentFav = fav
      localStorage.radishSearchData = ''
      this.$refs.radishList.searchData = { 工作年限: [0, 30] }
      this.$refs.radishList.query = {}
      this.$nextTick(function() {
        this.$refs.radishList.setDefault()
      })
    },
    setCurrentCon: function(con) {
      this.currentCon = con
      this.$nextTick(function() {
        this.$refs.radishList.searchData = con.condition
        this.$refs.radishList.handleSearch()
      })
    },
    showUpload: function() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadSuccess: async function(response, file, fileList) {
      if (!response || response.length === 0) return
      this.files.push(response[0])
      if (this.files.length >= 3 && fileList.length <= this.files.length) {
        this.matching = true
        this.$refs.UploadDialog.visible()
        console.log('res, ', this.files)
        const radishes = []
        for (let i = 0; i < this.files.length; i++) {
          try {
            const { md5 } = this.files[i]
            const fileData = await app.service('file').analyse({ md5 })
            if (fileData['手机']) {
              console.log(fileData['手机'])
              const dup = await app.service('radish').duplicate({ phone: fileData['手机'] })
              if (dup.msg === 'duplicate') {
                radishes.push(dup.data)
              }
            }
          } catch (error) {
            console.error(error)
          }
        }
        this.matching = false
        if (radishes.length === 0) {
          // app.root.$refs.drawer.search({ type: '人选', keywords: '', result: [] })
          return this.$message.info('暂无对应人选')
        }
        // const radishes = [{ id: 'H1HZ-12oOV4m' }, { id: 'r1R238hfE' }, { id: 'Hy-kRHbJmN' }]
        const rids = radishes.map(r => r.id)
        await this.recommendMatch({ rids })
        this.$refs.UploadDialog.clean()
        this.files = []
      }
    },
    recommendMatch: async function(param) {
      this.matching = true
      try {
        const match = await app.service('radish').recommendMatch(param)
        if (match.status === 'success') {
          app.root.onPull()
          app.root.$refs.drawer.search({ type: '人选', keywords: '', result: match.data })
          this.matchPid = ''
        } else if (match.data && match.data.pid) {
          if (!this.matchPid) {
            this.$message.info('暂无匹配结果, 可点击重试')
            this.matchPid = match.data.pid
          } else {
            this.$message.info('无匹配结果')
            this.matchPid = ''
          }
        } else {
          this.$message.error(match.msg)
          this.matchPid = ''
        }
      } catch (e) {
        console.error(e)
      }
      this.matching = false
    },
  },
}
</script>
<style>
.match-btn {
  position: fixed;
  top: 70px;
  right: 20px;
}
</style>
